import { render, staticRenderFns } from "./comparativeBooking.vue?vue&type=template&id=4bbd1e51&scoped=true&"
import script from "./comparativeBooking.vue?vue&type=script&lang=js&"
export * from "./comparativeBooking.vue?vue&type=script&lang=js&"
import style0 from "./comparativeBooking.vue?vue&type=style&index=0&id=4bbd1e51&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbd1e51",
  null
  
)

export default component.exports